<!--模板界面-->
<template>
	<div class="bg">
		<p class="titleText">负荷曲线</p>
		<img src="../../../../public/static/杭州东杰定制/看板/站点概况/titleBottom.png" style="margin: 10px 0;width: 100%;">
		<vchart ref='vchartLine' themes="dongjieEchart"></vchart>
	</div>
</template>

<script>
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			vchart
		},
		props: {},
		data() {
			return {
				todayLoadLine: [],
			}
		},
		created() {},
		mounted() {
			debugPage = this
			addNewTask("refreshUnitDayInfo", 0, 5 * 60 * 1000, -1, () => {
				this.getLoadValue(this.nowUnit.id)
			})
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			xList() {
				var list = []
				for (var h = 0, len = 24; h < len; h++) {
					for (var m = 0, lenm = 60; m < lenm; m += 5) {
						list.push((h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m)
					}
				}
				return list
			},
			getLine() {
				return {
					xAxis: {
						type: 'category',
						axisLabel: {
							interval: 23
						},
						data: this.xList,
					},
					yAxis: {
						type: 'value',
						name: '负荷值（kW）',
					},
					legend: {
						data: ['前日负荷','昨日负荷','今日负荷'],
						x: 'right',
						y: '10px',
						width: '20px',
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							label: {
								backgroundColor: '#6a7985'
							}
						}
					},
					backgroundColor: '',
					grid: {
						height: '80%',
						left: '8%',
						right: '5%',
						bottom: '5%',
						containLabel: true
					},
					dataZoom: [{
						type: 'inside',
						start: 0,
						end: 100
					}],
					series: this.todayLoadLine
				}
			},
		},
		watch: {
			getLine(nv, ov) {
				this.$refs.vchartLine.setData(nv, true)
			},
			nowUnit(nv, ov) {
				this.getLoadValue(nv.id)
			}
		},
		methods: {
			getLoadValue(unitId) {
				//获取单位相关的数据
				if (isempty(unitId)) {
					return
				}
				//获取当日负荷曲线
				var ser = []
				this.$api.powerApi.getUnitDayLoadValues(unitId, new Date(getDay(-2) + ' 00:00:00').getTime(),respon => {
					ser.push({
						data: respon,
						type: 'line',
						markPoint: {
							data: [{
								name: '最大值',
								type: 'max'
							}]
						},
						name: '前日负荷'
					})
				})
				this.$api.powerApi.getUnitDayLoadValues(unitId, new Date(getDay(-1) + ' 00:00:00').getTime(),respon => {
					ser.push({
						data: respon,
						type: 'line',
						markPoint: {
							data: [{
								name: '最大值',
								type: 'max'
							}]
						},
						name: '昨日负荷'
					})
				})
				this.$api.powerApi.getUnitDayLoadValues(unitId, new Date(getDay(0) + ' 00:00:00').getTime(),respon => {
					ser.push({
						data: respon,
						type: 'line',
						markPoint: {
							data: [{
								name: '最大值',
								type: 'max'
							}]
						},
						name: '今日负荷'
					})
				})
				this.todayLoadLine = ser
			}
		}
	}
</script>

<style scoped>
	>>>.default-chart {
		height: calc(100% - 50px) !important;
		width: 100% !important;
	}
</style>
